// extracted by mini-css-extract-plugin
export default {"Ruby":"ruby_Ruby__oXMJt"};